import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import CustomerSettings from './customer-settings-model'
import {
  CreateCustomerSettingsAsync,
  DeleteCustomerSettingsAsync,
  LoadCustomerSettingssAsync,
} from './customerSettings-thunk'
const initialState: customerSettingsSliceState = {
  customerSettings: [],
  selected_customerSettings: '',
  is_loading_customerSettings: false,
  is_creating_customerSettings: false,
  is_deleting_customerSettings: false,
}
export interface customerSettingsSliceState {
  customerSettings: CustomerSettings[]
  selected_customerSettings?: string
  is_loading_customerSettings: boolean
  is_creating_customerSettings: boolean
  is_deleting_customerSettings: boolean
}
export const customerSettingsSlice = createSlice({
  name: 'customerSettings',
  initialState,
  reducers: {
    setSelectedcustomerSettings: (state, action) => {
      state.selected_customerSettings = action.payload
    },
    clearStatecustomerSettings: (state) => {
      state.customerSettings = []
      state.is_loading_customerSettings = false
      state.is_creating_customerSettings = false
      state.is_deleting_customerSettings = false
    },
    mergecustomerSettings: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_customerSettings = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.customerSettings = merge(state.customerSettings, payload) as any
        }
      }
    },

    add_customerSettings: (state, action) => {
      if (action.payload) {
        state.customerSettings = [...state.customerSettings, action.payload]
      }
    },
    set_customerSettings: (state, action) => {
      let { key, value, id } = action.payload
      state.customerSettings = state.customerSettings.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCustomerSettingssAsync.pending, (state) => {
      state.is_loading_customerSettings = true
    })
    builder.addCase(LoadCustomerSettingssAsync.fulfilled, (state, action) => {
      state.is_loading_customerSettings = false
      if (action.payload) {
        state.customerSettings = action.payload
      }
    })
    builder.addCase(LoadCustomerSettingssAsync.rejected, (state) => {
      state.is_loading_customerSettings = false
    })
    builder.addCase(CreateCustomerSettingsAsync.pending, (state) => {
      state.is_creating_customerSettings = true
    })
    builder.addCase(CreateCustomerSettingsAsync.fulfilled, (state) => {
      state.is_creating_customerSettings = false
    })
    builder.addCase(CreateCustomerSettingsAsync.rejected, (state) => {
      state.is_creating_customerSettings = false
    })
    builder.addCase(DeleteCustomerSettingsAsync.pending, (state) => {
      state.is_deleting_customerSettings = true
    })
    builder.addCase(DeleteCustomerSettingsAsync.fulfilled, (state, action) => {
      state.is_deleting_customerSettings = false
      if (state.customerSettings) {
        state.customerSettings = state.customerSettings.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteCustomerSettingsAsync.rejected, (state) => {
      state.is_deleting_customerSettings = false
    })

    builder.addCase(autoThunks.get_customer_settings.pending, (state) => {
      state.is_loading_customerSettings = true
    })
    builder.addCase(
      autoThunks.get_customer_settings.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_customer_settings.rejected, (state) => {
      state.is_loading_customerSettings = false
    })

    builder.addCase(
      autoThunks.get_customer_settings_as_admin.pending,
      (state) => {
        state.is_loading_customerSettings = true
      },
    )
    builder.addCase(
      autoThunks.get_customer_settings_as_admin.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_customer_settings_as_admin.rejected,
      (state) => {
        state.is_loading_customerSettings = false
      },
    )

    builder.addCase(
      autoThunks.assign_customer_coherent_screen.pending,
      (state) => {
        state.is_loading_customerSettings = true
      },
    )
    builder.addCase(
      autoThunks.assign_customer_coherent_screen.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.assign_customer_coherent_screen.rejected,
      (state) => {
        state.is_loading_customerSettings = false
      },
    )

    builder.addCase(
      autoThunks.get_customer_settings_as_customer.pending,
      (state) => {
        state.is_loading_customerSettings = true
      },
    )
    builder.addCase(
      autoThunks.get_customer_settings_as_customer.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_customer_settings_as_customer.rejected,
      (state) => {
        state.is_loading_customerSettings = false
      },
    )

    builder.addCase(autoThunks.fetch_customer_settings.pending, (state) => {
      state.is_loading_customerSettings = true
    })
    builder.addCase(
      autoThunks.fetch_customer_settings.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.fetch_customer_settings.rejected, (state) => {
      state.is_loading_customerSettings = false
    })

    builder.addCase(autoThunks.store_customer_settings.pending, (state) => {
      state.is_loading_customerSettings = true
    })
    builder.addCase(
      autoThunks.store_customer_settings.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.store_customer_settings.rejected, (state) => {
      state.is_loading_customerSettings = false
    })

    builder.addCase(
      autoThunks.fetch_customer_settings_for_domain.pending,
      (state) => {
        state.is_loading_customerSettings = true
      },
    )
    builder.addCase(
      autoThunks.fetch_customer_settings_for_domain.fulfilled,
      (state, action) => {
        state.is_loading_customerSettings = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.fetch_customer_settings_for_domain.rejected,
      (state) => {
        state.is_loading_customerSettings = false
      },
    )
  },
})

function handleResult(action: any, state: customerSettingsSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_customerSettings = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.customerSettings = merge(state.customerSettings, payload) as any
    }
  }
}

export const {
  clearStatecustomerSettings,
  setSelectedcustomerSettings,
  set_customerSettings,
  mergecustomerSettings,
  add_customerSettings,
} = customerSettingsSlice.actions

export const get_customerSettings =
  (id?: string) =>
  (state: {
    customerSettings: {
      customerSettings: CustomerSettings[]
    }
  }): CustomerSettings | null => {
    let temp = state?.customerSettings?.customerSettings?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.customerSettings?.customerSettings[0] || null
  }
export const get_selected_customerSettings = (state: {
  customerSettings: customerSettingsSliceState
}): CustomerSettings | null => {
  let id = state?.customerSettings?.selected_customerSettings
  let temp = state?.customerSettings?.customerSettings?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_customerSettings = (state: {
  customerSettings: {
    customerSettings: CustomerSettings[]
  }
}): CustomerSettings[] => {
  let temp = state?.customerSettings?.customerSettings
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_customerSettings_busy = (state: {
  customerSettings: customerSettingsSliceState
}) => {
  return (
    state?.customerSettings.is_deleting_customerSettings ||
    state?.customerSettings.is_loading_customerSettings ||
    state?.customerSettings.is_creating_customerSettings
  )
}
export const is_deleting_customerSettings_busy = (state: {
  customerSettings: customerSettingsSliceState
}) => {
  return state?.customerSettings.is_deleting_customerSettings
}
export const is_loading_customerSettings_busy = (state: {
  customerSettings: customerSettingsSliceState
}) => {
  return state?.customerSettings.is_loading_customerSettings
}
export const is_creating_customerSettings_busy = (state: {
  customerSettings: customerSettingsSliceState
}) => {
  return state?.customerSettings.is_creating_customerSettings
}

export default customerSettingsSlice.reducer
